import Label from "Components/Common/components/Label";
import Validate from "Components/GMS/Pdw/upload/Validate";
import React from "react";
import { Modal } from "react-bootstrap";

const ValidatePDW = (props) => {
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.showValidatePopup}
      onHide={props.modalValidateClose}
    >
      <Modal.Header closeButton>
        <div>
          <Label
            message={props?.type === "CBM" ? "Validate XLS" : "Upload XLS - Validate"}
            fontSize={0.875}
            fontWeight="600"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="m-2">
            <div className="row">
              <Validate modalValidateClose={props.modalValidateClose} ruleId={props.ruleId} type={props.type} compatibilityLevel={props.compatibilityLevel} fetchData={props.fetchData}/>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ValidatePDW;
